import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Smartphone, UtensilsCrossed, Plane, Gamepad, Car, Wrench, Scissors, Music, Tv, Coffee, Book } from 'lucide-react';
interface CategoryProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}
export function DynamicCategories({
  activeCategory,
  onCategoryChange
}: CategoryProps) {
  const [showAll, setShowAll] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const allCategories = [{
    id: 'electronics',
    name: 'Electronics',
    icon: <Smartphone size={22} data-id="element-170" />
  }, {
    id: 'food',
    name: 'Food',
    icon: <UtensilsCrossed size={22} data-id="element-171" />
  }, {
    id: 'fashion',
    name: 'Fashion',
    icon: <ShoppingBag size={22} data-id="element-172" />
  }, {
    id: 'travel',
    name: 'Travel',
    icon: <Plane size={22} data-id="element-173" />
  }, {
    id: 'games',
    name: 'Games',
    icon: <Gamepad size={22} data-id="element-174" />
  }, {
    id: 'car',
    name: 'Auto',
    icon: <Car size={22} data-id="element-175" />
  }, {
    id: 'service',
    name: 'Services',
    icon: <Wrench size={22} data-id="element-176" />
  }, {
    id: 'spa',
    name: 'Beauty',
    icon: <Scissors size={22} data-id="element-177" />
  }, {
    id: 'music',
    name: 'Music',
    icon: <Music size={22} data-id="element-178" />
  }, {
    id: 'entertainment',
    name: 'TV & Film',
    icon: <Tv size={22} data-id="element-179" />
  }, {
    id: 'cafe',
    name: 'Cafes',
    icon: <Coffee size={22} data-id="element-180" />
  }, {
    id: 'books',
    name: 'Books',
    icon: <Book size={22} data-id="element-181" />
  }];
  // Initially show only 8 categories, show all when "Show All" is clicked
  const visibleCategories = showAll ? allCategories : allCategories.slice(0, 8);
  return <section className="mb-8" data-id="element-182">
      <div className="flex justify-between items-center mb-4" data-id="element-183">
        <h2 className="text-xl font-bold" data-id="element-184">Categories</h2>
        <button onClick={() => setShowAll(!showAll)} className="text-gray-500 text-sm hover:underline" data-id="element-185">
          {showAll ? 'Show Less' : 'Show All'}
        </button>
      </div>
      <div ref={containerRef} className="grid grid-cols-4 gap-3" data-id="element-186">
        {visibleCategories.map(category => {
        const isActive = activeCategory === category.id;
        return <motion.div key={category.id} layout initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.15
        }} className={`flex flex-col items-center p-3 rounded-lg cursor-pointer ${isActive ? 'bg-gray-900 text-white' : 'bg-gray-50 hover:bg-gray-100'}`} onClick={() => onCategoryChange(category.id)} whileTap={{
          scale: 0.97
        }} data-id="element-187">
              <div className={`p-2 rounded-full mb-2 ${isActive ? 'bg-white/20' : 'bg-white'}`} data-id="element-188">
                <div className={isActive ? 'text-white' : 'text-black'} data-id="element-189">
                  {category.icon}
                </div>
              </div>
              <span className="text-xs text-center" data-id="element-190">{category.name}</span>
              {isActive && <motion.div className="h-0.5 w-5 bg-white rounded-full mt-1" layoutId="activeCategoryIndicator" data-id="element-191" />}
            </motion.div>;
      })}
      </div>
    </section>;
}